import React from 'react';
import {
  Container,
  Template,
  Title,
  Summary,
  InformationWrapper,
  Information,
  DateWrapper,
  Date,
  PaymentShops,
  Separator,
  PaymentMethods,
  StepsWrapper,
  Step
} from './styled';
import {
  Line,
  Circle,
  HeaderLine
} from '@app/src/view/Loading/template/components/Shimmer';

export const TemplateShimmer: React.FC = () => (
  <Container>
    <Template>
        <HeaderLine height={80} />
      <Summary>
        <Title>
          <Line width={600} marginBotton={32} />
        </Title>
        <InformationWrapper>
          <HeaderLine height={64} />
          <Information>
            <Line width={135} height={24} marginBotton={8} />
            <Line width={57} height={24 } />
          </Information>
          <Information>
            <Line width={91} height={24} marginBotton={8} />
            <Line width={202} height={24 } />
          </Information>
        </InformationWrapper>
        <DateWrapper>
          <Circle width={24} height={24} />
          <Date>
            <Line height={24} />
          </Date>
        </DateWrapper>
        <Line width={197} height={24} marginBotton={8} />
        <Line width={256} height={80} marginBotton={39} />
      </Summary>
      <Separator />
      <PaymentShops>
        <Line width={197} height={24} marginBotton={24} />
        <Line width={592} height={24} marginBotton={8} />
        <Line width={504} height={24} marginBotton={42} />
      </PaymentShops>
      <PaymentMethods>
        <StepsWrapper>
          <Step>
            <Line width={375} height={24} marginBotton={8} />
            <Line width={132} height={24} marginBotton={8} />
            <Line width={375} height={24} marginBotton={24} />
          </Step>
          <Step>
            <Line width={276} height={24} marginBotton={8} />
            <Line width={392} height={24} marginBotton={8} />
            <Line width={275} height={24} marginBotton={24} />
          </Step>
        </StepsWrapper>
      </PaymentMethods>
    </Template>
  </Container>
);
